import { render, staticRenderFns } from "./DatetimeSpan.vue?vue&type=template&id=1894b1f6&"
import script from "./DatetimeSpan.vue?vue&type=script&lang=ts&"
export * from "./DatetimeSpan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports